import { Text } from '@billy/design-system'
import styled from '@emotion/styled'

// TODO retheming 2026 - get rid of (Text), which is an antipattern
export const TitleWrapper = styled(Text)``
